// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbj_a"};